import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setElements, batchSaveElements, toggleSidebar } from '@/store/actions'
import {
  getTranslation,
  getElements,
  getToken,
  getSidebarOpened,
  getActiveElement
} from '@/store/getters'
import { withDragAndDrop } from '@/hocs/withDragAndDrop'

import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'

const elementsShape = {
  text: 'text',
  image: 'image',
  iframe: 'iframe',
  video: 'video',
  circle: 'shape',
  square: 'shape',
  triangle: 'shape',
  rhombus: 'shape',
  line: 'shape',
  arrow: 'shape',
  star: 'shape'
}

class Layers extends Component {

  handleDragEnd = () => {
    const { dragCallbacks } = this.props
    const { dragData, dropData } = dragCallbacks.getDragData()

    dragCallbacks.onDragEnd()

    this.updateElements(dragData.index, dropData.index)
  }

  updateElements(from, to) {
    const { elements, token, batchSaveElements } = this.props
    const toSwap = elements[to]
    const fromSwap = elements[from]
    const tempIndex = toSwap.position || toSwap.content.styles.zIndex

    toSwap.position = fromSwap.position || fromSwap.content.styles.zIndex
    toSwap.content.styles = {
      ...toSwap.content.styles,
      zIndex: fromSwap.position
    }
    fromSwap.position = tempIndex
    fromSwap.content.styles = {
      ...fromSwap.content.styles,
      zIndex: tempIndex
    }

    batchSaveElements({
      id_page: toSwap.id_page,
      accessToken: token,
      elements: [toSwap, fromSwap]
    })

    this.swapElements(from, to)
  }

  swapElements = (from, to) => {
    const { elements, setElements } = this.props
    const toSwap = elements[to]
    elements[to] = elements[from]
    elements[from] = toSwap
    setElements(elements)
  }

  render() {
    const { sidebarOpened, dragCallbacks, elements, actualElement } = this.props
    const { onStartDrag, onDragOver, onDragEnter, onDragLeave } = dragCallbacks
    const { isOpened, name } = sidebarOpened

    if (isOpened && (name === 'layers' || name === null)) {
      return (
        <ul className={styles['wrapper-layers__elements']}>
          {elements.map((element, index) => (
            <li
              className={actualElement && actualElement.id === element.id ? styles['wrapper-layers__element'] : ''}
              key={element.id}
              draggable="true"
              onDragStart={e => onStartDrag(e, { id: element.id, index })}
              onDragOver={e => onDragOver(e, { id: element.id, index })}
              onDragEnter={e => onDragEnter(e)}
              onDragLeave={e => onDragLeave(e)}
              onDragEnd={this.handleDragEnd}
            >
              <i className="material-icons">drag_handle</i>
              <IconComponent
                icon={elementsShape[element.content.elementType]}
              />
              <span>{element.content.elementType}</span>
            </li>
          ))}
        </ul>
      )
    } else {
      return null
    }
  }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const sidebarOpened = getSidebarOpened(state)
  const token = getToken(state)
  const elements = getElements(state)
  const actualElement = getActiveElement(state)

  return { translation, sidebarOpened, token, elements, actualElement }
}

export default withDragAndDrop(connect(
  mapStateToProps,
  {
    setElements,
    batchSaveElements,
    toggleSidebar
  }
)(Layers)
)



// WEBPACK FOOTER //
// ./src/pages/Editor/components/Layers/index.js